import React from "react";
import { ControlLabel, Button, Alert, FormControl } from "react-bootstrap";
import ajax from "./../../lib/ajax.js";
import context from "./../../lib/context.js";
import ReportsParameterApprover from "./reports-parameter-approver.jsx";
import PayrollStaffAutoComplete from "./../../view/shared/payroll-staff-autocomplete.jsx";

export default class ReportsEmployeePtoBalanceReport extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            year: 'current',
            approver: '',
            errors: []
        }

        this.onRunReport = this.onRunReport.bind(this);
        this.handleYearChange = this.handleYearChange.bind(this);
        this.handleApproverChange = this.handleApproverChange.bind(this);
        this.runReport = this.runReport.bind(this);
        this.loadReportViewModel = this.loadReportViewModel.bind(this);
        this.isAndroid = this.isAndroid.bind(this);
        this.isIos = this.isIos.bind(this);
        this.validate = this.validate.bind(this);
    }

    componentDidMount() {
        this.loadReportViewModel();
    }

    loadReportViewModel() {
        let self = this;

        context.message({
            show: true, 
            type: "loading", 
            message:"Loading. Please wait..."
        });

        ajax.vm().get(this.props.role + "/reports-employee-pto-balance-report")
            .then(function (res) {
                debugger;
                self.setState({
                    reportCode: res.data.reportCode,
                    keys: res.data.keys,
                    role: res.data.role,
                    id: res.data.id,
                    approver: '', 
                    username: res.data.username,
                    currentAnniversaryYearLabel: res.data.currentAnniversaryYearLabel,
                    previousAnniversaryYearLabel: res.data.previousAnniversaryYearLabel,
                    runReportLabel: res.data.runReportLabel,
                    approverRequiredLabel: res.data.approverRequiredLabel,
                    noStaffFoundForApproverLabel: res.data.noStaffFoundForApproverLabel,
                    name: res.data.name,
                    approverPeopleList: res.data.approverPeopleList
                });

                context.message({ show: false });
            })
            .catch(function (err) {
                let data = err.response.data;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }

    onRunReport() {
        var messages = this.validate();
        this.setState({
            errors: messages
        });

        if (messages.length == 0) {
            this.runReport();
        }
    }

    validate() {
        let msg = [];

        if (this.props.role == 'payroll-admin') {
            if (this.state.approver.toString().length == 0) {
                msg.push(this.state.approverRequiredLabel);
            }
        }

        return msg;
    }

    runReport() {
        let self = this;

        context.message({
            show: true, 
            type: "loading", 
            message:"Loading. Please wait..."
        });
        
        ajax.api().get(`get-people-by-approver-direct-reports`, {
            params: {
                approverId: this.props.role == 'supervisor' && this.state.approver == '' ? this.state.id : this.state.approver,
                includeApprover: true
            }
        })
        .then(function (res) {
            var empNos = '';

            if (res.data.length) {
                for (var i = 0; i < res.data.length; i++) {
                    if (res.data[i].clarusEmpNo != null) {
                        empNos += res.data[i].clarusEmpNo + ',';
                    }
                }

                if (empNos.length > 0) {
                    empNos = empNos.substring(0, empNos.length - 1);
                } 
    
                var isAndroid = self.isAndroid();
                var isIos = self.isIos();
    
                // Open only for desktop
                if (isAndroid == false && isIos == false) {
                    var myWindow = window.open("", "_blank");
                    myWindow.document.write("<div id='divLoadMessage'>Please wait while report is loading...</div>");
                }
    
                var values =
                    "|" +
                    self.state.year + "|" +
                    empNos + "|" +
                    self.state.username;
    
                var params = {
                    ReportCode: self.state.reportCode,
                    ReportFormat: "PDF",
                    Keys: self.state.keys,
                    Values: values
                };
    
                ajax.api().put(`save-report`, params)
                .then(function (res) {
                    if (isAndroid || isIos) {
                        self.setState({
                            pdfUrl: res.data.filePath
                        });
                        setTimeout(function() {
                            document.getElementById('aMobileOpener').click();
                        }, 10);
                    } else {
                        myWindow.document.write("<script type='text/javascript'>document.getElementById('divLoadMessage').style.display = 'none';</script>");
                        myWindow.document.write("<iframe src='" + res.data.filePath + "' style='width: 100%; height: 100%;'></iframe>");
                    }
                    context.message({ show: false });
                })
                .catch(function (err) {
                    let data = err.response.data;
                    context.message({
                        show: true,
                        type: "error",
                        message: data.exceptionMessage || data.message,
                        buttons: "close"
                    });
                    if (isAndroid == false && isIos == false) {
                        myWindow.close();
                    }
                });
            }
            else {
                var errors = [];
                errors.push(self.state.noStaffFoundForApproverLabel);
                self.setState({
                    errors: errors
                });
                context.message({ show: false });
            }
        })
        .catch(function (err) {
            let data = err.response.data;
            context.message({
                show: true,
                type: "error",
                message: data.exceptionMessage || data.message,
                buttons: "close"
            });
        }); 
    }

    isAndroid() {
        var ua = navigator.userAgent.toLowerCase();
        return ua.indexOf("android") > -1;
    }

    isIos() {
        var ua = navigator.userAgent.toLowerCase();
        return ua.indexOf('ipad') > - 1 || ua.indexOf('iphone') > -1;
    }

    getFormattedDate(id) {
        return document.getElementById(id).getAttribute("data-formattedvalue").trim(); // accessed value from dom because handle change isn't fired when removed
    }

    handleYearChange(event) {
        this.setState({
            year: event.target.value
        });
    }

    handleApproverChange(approverId, name) {
        this.setState({
            approver: approverId
        });
    }

    render() {
        var rowStyle = {
            "padding-top": "10px"
        };

        var requiredStyle = {
            "color": "red"
        };

        var displayNone = {
            "display": "none"
        };

        return (
            <div className="container-fluid">
                <a id="aMobileOpener" href={this.state.pdfUrl} style={displayNone}></a>
                <div className="row">
                    <div className="col-md-6 col-lg-6">
                        <div className="col-md-12 col-lg-12">
                            <FormControl componentClass="select" defaultValue={this.state.year} onChange={this.handleYearChange}>
                                <option key="current" value="current">{this.state.currentAnniversaryYearLabel}</option>
                                <option key="past" value="past">{this.state.previousAnniversaryYearLabel}</option>
                            </FormControl>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-6">
                        <div className="col-md-12 col-lg-12">
                            <ReportsParameterApprover 
                                role={this.props.role} 
                                onChange={this.handleApproverChange} 
                                approverid={this.state.id} 
                                approverName={this.state.name} 
                                includeCurrentApprover={true} />
                        </div>
                    </div>
                </div>
                <div className="row" style={rowStyle}>
                    <div className="col-md-6 col-lg-6">
                        <div className="col-md-12 col-lg-12">
                            <Button onClick={this.onRunReport} className="btn-info ap-fullsize">{this.state.runReportLabel}</Button>
                        </div>
                    </div>
                </div>
                <div className="row" style={rowStyle}>
                    <div className="col-md-12 col-lg-12">
                        <div className="col-md-12 col-lg-12">
                            <Alert bsStyle="danger" className={this.state.errors.length > 0 ? "" : "ap-hidden"}>
                                <ul>
                                    {this.state.errors.map(m =>
                                        <li key={m}>{m}</li>)}
                                </ul>
                            </Alert>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}